'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var INIT = exports.INIT = 'RD/INIT';
var SET_REF = exports.SET_REF = 'RD/SET_REF';
var UPDATE_EDITOR_STATE = exports.UPDATE_EDITOR_STATE = 'RD/UPDATE_EDITOR_STATE';
var UPDATE_EDITOR_STATE_FROM_RAW = exports.UPDATE_EDITOR_STATE_FROM_RAW = 'RD/UPDATE_EDITOR_STATE_FROM_RAW';
var UPDATE_READ_ONLY = exports.UPDATE_READ_ONLY = 'RD/UPDATE_READ_ONLY';
var TOGGLE_BLOCK = exports.TOGGLE_BLOCK = 'RD/TOGGLE_BLOCK';
var TOGGLE_STYLE = exports.TOGGLE_STYLE = 'RD/TOGGLE_STYLE';
var APPLY_BLOCK = exports.APPLY_BLOCK = 'RD/APPLY_BLOCK';
var REMOVE_ENTITY = exports.REMOVE_ENTITY = 'RD/REMOVE_ENTITY';
var APPLY_ENTITY = exports.APPLY_ENTITY = 'RD/APPLY_ENTITY';
var INSERT_ENTITY = exports.INSERT_ENTITY = 'RD/INSERT_ENTITY';
var INSERT_ATOMIC_BLOCK = exports.INSERT_ATOMIC_BLOCK = 'RD/INSERT_ATOMIC_BLOCK';
var REMOVE_BLOCK = exports.REMOVE_BLOCK = 'RD/REMOVE_BLOCK';
var UPDATE_ENTITY_DATA = exports.UPDATE_ENTITY_DATA = 'RD/UPDATE_ENTITY_DATA';
//# sourceMappingURL=data:application/json;charset=utf8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImNvbnN0YW50cy9BY3Rpb25UeXBlcy5qcyJdLCJuYW1lcyI6WyJJTklUIiwiU0VUX1JFRiIsIlVQREFURV9FRElUT1JfU1RBVEUiLCJVUERBVEVfRURJVE9SX1NUQVRFX0ZST01fUkFXIiwiVVBEQVRFX1JFQURfT05MWSIsIlRPR0dMRV9CTE9DSyIsIlRPR0dMRV9TVFlMRSIsIkFQUExZX0JMT0NLIiwiUkVNT1ZFX0VOVElUWSIsIkFQUExZX0VOVElUWSIsIklOU0VSVF9FTlRJVFkiLCJJTlNFUlRfQVRPTUlDX0JMT0NLIiwiUkVNT1ZFX0JMT0NLIiwiVVBEQVRFX0VOVElUWV9EQVRBIl0sIm1hcHBpbmdzIjoiOzs7OztBQUFPLElBQU1BLHNCQUFPLFNBQWI7QUFDQSxJQUFNQyw0QkFBVSxZQUFoQjtBQUNBLElBQU1DLG9EQUFzQix3QkFBNUI7QUFDQSxJQUFNQyxzRUFBK0IsaUNBQXJDO0FBQ0EsSUFBTUMsOENBQW1CLHFCQUF6QjtBQUNBLElBQU1DLHNDQUFlLGlCQUFyQjtBQUNBLElBQU1DLHNDQUFlLGlCQUFyQjtBQUNBLElBQU1DLG9DQUFjLGdCQUFwQjtBQUNBLElBQU1DLHdDQUFnQixrQkFBdEI7QUFDQSxJQUFNQyxzQ0FBZSxpQkFBckI7QUFDQSxJQUFNQyx3Q0FBZ0Isa0JBQXRCO0FBQ0EsSUFBTUMsb0RBQXNCLHdCQUE1QjtBQUNBLElBQU1DLHNDQUFlLGlCQUFyQjtBQUNBLElBQU1DLGtEQUFxQix1QkFBM0IiLCJmaWxlIjoiY29uc3RhbnRzL0FjdGlvblR5cGVzLmpzIiwic291cmNlUm9vdCI6IkU6XFxwcm9qZWN0c1xccmVkdXgtZHJhZnRcXHNyYyJ9



//////////////////
// WEBPACK FOOTER
// ../lib/constants/ActionTypes.js
// module id = 266
// module chunks = 0